import { render, staticRenderFns } from "./PxCreateQuestionPageInModel.vue?vue&type=template&id=760d1c25&scoped=true"
import script from "./PxCreateQuestionPageInModel.vue?vue&type=script&lang=js"
export * from "./PxCreateQuestionPageInModel.vue?vue&type=script&lang=js"
import style0 from "./PxCreateQuestionPageInModel.vue?vue&type=style&index=0&id=760d1c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760d1c25",
  null
  
)

export default component.exports